import styled from '@emotion/styled';
import { NewArrow } from '../carousel/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: normal;
  position: relative;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const ArrowsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ArrowsWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Arrow = styled(NewArrow)`
  height: 48px;

  ${({ disabled, theme }) => disabled && `
    svg path {
      stroke: ${theme.colors.neutrals.grey5};
    }
  `}
`;

export const MadadPagerContainer = styled.div`
  ${({ theme }) => `
      width: 100vw;
      overflow: hidden;
      margin: -${theme.spacing(2)} -${theme.spacing(3)} 0;
      .view-pager-rail {
        overflow: visible;

        .view-pager-bow > div {
          margin-top: ${theme.spacing(2)};
        }

        .view-pager-bow > div:last-of-type {
          margin-left: ${theme.spacing(3)};
        }
        .view-pager-bow > div:first-of-type {
          margin-right: ${theme.spacing(3)};
        }
      }
  `}
  ${({ theme }) => theme.media.showAt({ from: 3 })`
      margin: -${theme.spacing(2)} -${theme.spacing(2)} 0;
      .view-pager-rail {
        overflow: visible;

        .view-pager-bow > div:last-of-type {
          margin-left: ${theme.spacing(2)};
        }
        .view-pager-bow > div:first-of-type {
          margin-right: ${theme.spacing(2)};
        }
      }
  `}
`;
